import * as React from 'react';
import CompanyPage2 from './CompanyPage2';

export default () => <CompanyPage2/>;

